import { Box, Button } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import RecordListNavbarRelatedActionsComponent from "modules/record/record-list/components/RecordListNavbarRelatedActions";

import { ResolvedRelatedList } from "../types";
import Translate from "component/global/translation/translation-component";
import { useRecordListContext } from "modules/record/record-list/hooks/useRecordListContext";

interface RelatedListToolbarProps {
    relatedList: ResolvedRelatedList;
    onEditRelationships: () => void;
    onNew: (event?: React.MouseEvent<HTMLElement>) => void;
}

const RelatedListToolbar = ({
    relatedList,
    onEditRelationships,
    onNew,
}: RelatedListToolbarProps) => {
    const { permissions, readDenied } = useRecordListContext();
    if (readDenied || permissions?.read === false) return null;
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 1,
                py: 0.5,
                flexWrap: "wrap",
                minWidth: 0,
            }}
        >
            {relatedList.allowNew && permissions?.create !== false && (
                <Button
                    size="small"
                    variant="contained"
                    startIcon={<AddOutlinedIcon fontSize="small" />}
                    onClick={onNew}
                >
                    <Translate fontSize="small" text="New" />
                </Button>
            )}
            {relatedList.relationshipType === "many_to_many" && relatedList.allowEditRelationships && permissions?.update !== false && (
                <Button
                    size="small"
                    variant="outlined"
                    startIcon={<EditOutlinedIcon fontSize="small" />}
                    onClick={onEditRelationships}
                >
                    <Translate fontSize="small" text="Edit" />
                </Button>
            )}
            <RecordListNavbarRelatedActionsComponent tableName={relatedList.tableName} />
        </Box>
    );
};

export default RelatedListToolbar;
